import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 0 4px;
`

export const Content = styled(Box)`
  width: 100%;
  padding: 6px 12px;
  border-radius: 30px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
`
